import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Title from '../title';
import { Time, TIME_FORMAT_COMPACT } from '../../../components/Time';
import Purchase from '../../lib/purchase';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  statusActive: {
    id: 'groupCard.statuses.active',
    defaultMessage: 'In Progress',
  },
  statusCanceled: {
    id: 'groupCard.statuses.canceled',
    defaultMessage: 'Canceled',
  },
  statusCompleted: {
    id: 'groupCard.statuses.completed',
    defaultMessage: 'Completed',
  },
  statusCreated: {
    id: 'groupCard.statuses.created',
    defaultMessage: 'Created',
  },
  organizedBy: {
    id: 'groupCard.organizedBy',
    defaultMessage: 'By {organizerName}',
  },

  contributors: {
    id: 'groupCard.contributors',
    defaultMessage: '{SlotsName}',
  },
  contributors_adult: {
    id: 'groupCard.contributors_adult',
    defaultMessage: 'Adults',
  },
  contributors_passenger: {
    id: 'groupCard.contributors_passenger',
    defaultMessage: 'Passengers',
  },
  contributors_ticket: {
    id: 'groupCard.contributors_ticket',
    defaultMessage: 'Tickets',
  },
  contributors_seat: {
    id: 'groupCard.contributors_seat',
    defaultMessage: 'Seats',
  },
  contributors_item: {
    id: 'groupCard.contributors_item',
    defaultMessage: 'Items',
  },
  contributors_shirt: {
    id: 'groupCard.contributors_shirt',
    defaultMessage: 'Shirts',
  },
  contributors_person: {
    id: 'groupCard.contributors_person',
    defaultMessage: 'People',
  },
  contributors_guest: {
    id: 'groupCard.contributors_guest',
    defaultMessage: 'Guests',
  },
  contributors_player: {
    id: 'groupCard.contributors_player',
    defaultMessage: 'Players',
  },
  contributors_student: {
    id: 'groupCard.contributors_student',
    defaultMessage: 'Students',
  },

});

const purchaseStatuses = {
  active: 'statusActive',
  canceled: 'statusCanceled',
  completed: 'statusCompleted',
  created: 'statusCreated',
}

class GroupCard extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
    this.onGoToGroup = this.onGoToGroup.bind(this);
  }

  onGoToGroup() {
    window.location.href = this.props.url;
  }

  getStatusCopy() {
    const { status } = this.props;
    const i18nKey = purchaseStatuses[status];
    return this.formatMessage(i18n[i18nKey]);
  }

  shouldRenderCommitDeadline() {
    return this.props.commitDeadline && !this.props.expired;
  }

  renderCommitDeadline() {
    if (!this.shouldRenderCommitDeadline()) return null;
    return (
      <div className="col-4">
        <span className="small-print">
          <FormattedMessage
            id="groupCard.joinBy"
            defaultMessage="Join by"
          />
        </span><br />
        <span><Time format={TIME_FORMAT_COMPACT} time={this.props.commitDeadline} /></span>
      </div>
    );
  }

  renderContributorsCount() {
    return (
      <div className="col-4">
        <span className="small-print">
          {this.formatMessage(i18n.contributors, this.props.purchase.slotName)}
        </span><br />
        <span>{this.props.committedMembers}</span>
      </div>
    );
  }

  renderGoToGroupButton() {
    return (
      <button
        className="btn btn-secondary active"
        type="button"
        onClick={this.onGoToGroup}
      >
        <FormattedMessage
          id="groupCard.goToGroup"
          defaultMessage="Go to group"
        />
      </button>
    );
  }

  renderImage() {
    return (
      <a href="#go-to-group" onClick={this.onGoToGroup}>
        <img
          alt={this.props.name}
          className="rounded img-fluid"
          src={this.props.imageUrl}
        />
      </a>
    );
  }

  renderInviteesCount() {
    return (
      <div className="col-4">
        <span className="small-print">
          <FormattedMessage
            id="groupCard.invitees"
            defaultMessage="Invitees"
          />
        </span><br />
        <span>{this.props.invitedMembers}</span>
      </div>
    );
  }

  renderKeyInfo() {
    return (
      <div className="row my-4">
        {this.renderContributorsCount()}
        {this.renderInviteesCount()}
        {this.renderCommitDeadline()}
      </div>
    );
  }

  renderStatusAndDate() {
    return (
      <div className="pt-2 pb-4">
        <span className="float-left cool-grey">
          {this.renderStatusIcon()}
          {this.getStatusCopy()}
        </span>
        <span className="float-right cool-grey">
          <FormattedMessage
            id="groupCard.statusAndDate.created"
            defaultMessage="Created:"
          /> <Time format={TIME_FORMAT_COMPACT} time={this.props.createdAt} />
        </span>
      </div>
    );
  }

  renderStatusIcon() {
    const { status, isCompleted } = this.props;
    let className = 'fa mr-2 ';
    if (isCompleted) className += 'fa-check-circle-o text-success';
    if (Purchase.isActive(status)) className += 'fa-play-circle-o text-success';
    if (Purchase.isCanceled(status)) className += 'fa-times-circle-o text-danger';
    return <i className={className} aria-hidden="true" />;
  }

  renderTitle() {
    const { name, organizerName } = this.props;
    return (
      <div>
        <a href="#go-to-group" onClick={this.onGoToGroup}>
          <Title text={name} className="pb-0" bigger />
        </a>
        <sub className="small-print">
          {this.formatMessage(i18n.organizedBy, { organizerName })}
        </sub>
      </div>
    );
  }

  render() {
    return (
      <div className="group-card col-4 mb-4 pr-3">
        <div className="card">
          {this.renderStatusAndDate()}
          {this.renderImage()}
          {this.renderTitle()}
          {this.renderKeyInfo()}
          {this.renderGoToGroupButton()}
        </div>
      </div>
    );
  }
}

GroupCard.defaultProps = {
  purchase: { slotName: null }
}

export default injectIntl(GroupCard);



// WEBPACK FOOTER //
// ./src/desktop/components/my-groups/group-card.js